<script>
   /**********************************************************************/
   /* StatCompSeries                                                     */
   /* --------------------                                               */
   /* shows line-scatter series with a statistic value vs. number of PCs */
   /**********************************************************************/

   import { Points, Lines } from 'svelte-plots-basic/2d';

   /*****************************************/
   /* Component parameters                  */
   /*****************************************/

   // inputs
   export let resobj;                              // JSON with result objects (SIMCA, PCA, etc)
   export let statName;                            // name of statistics to show (variance, sensitivity, etc.)
   export let ncomp;                               // number of selected components
   export let lineColor;                           // color of lines and marker border
   export let faceColor;                           // color of marker face

   // outputs
   export let minVal = Number.POSITIVE_INFINITY;   // smallest value of the statistic
   export let maxVal = Number.NEGATIVE_INFINITY;   // largest value of the statistic

   /*****************************************/
   /* Component code                        */
   /*****************************************/
   let x, y, l;
   $: if (resobj && resobj.stat && Object.keys(resobj.stat).includes(statName)) {
      x = resobj.stat.components;
      y = resobj.stat[statName];
      l = y.map(v => v >= 10 ? v.toFixed(1) : (v >= 1 ? v.toFixed(2) : v.toFixed(3)));
      for (let i = 0; i < y.length; i++) {
         minVal = Math.min(minVal, y[i]);
         maxVal = Math.max(maxVal, y[i]);
      }
   } else {
      x = null;
      y = null;
      minVal = Number.POSITIVE_INFINITY;
      maxVal = Number.NEGATIVE_INFINITY;
   }

</script>

{#if x && y }
   <!-- data points with statistics -->
   <Lines xValues={x} yValues={y} lineWidth={1.5} lineColor={lineColor} />
   <Points xValues={x} yValues={y} borderWidth={1.5} faceColor={faceColor} borderColor={lineColor}/>

   <!-- data point with statistic value for selected component -->
   {#if ncomp > 0}
   <Points
      xValues={[x[ncomp - 1]]}
      yValues={[y[ncomp - 1]]}
      markerSize={1.5}
      borderWidth={1.5}
      faceColor={lineColor}
      borderColor='#a0a0a0'
   />
   {/if}

   <!--
   <TextLabels xValues={x} yValues={y} labels={l} pos={3} faceColor={LABELS_COLOR} fontSize={0.8}/>
   -->
{/if}